// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_full_screen_content-module--container--13kGM"};